import { TESTIMONIALS } from "@/lib/data";
import { useReveal } from "@/hooks/useReveal";

export const Testimonials = () => {
  const ref = useReveal();
  return (
    <section id="anbefalinger" className="pt-20 pb-12 lg:pt-24 lg:pb-16 bg-white/[0.015] border-y border-white/5">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div ref={ref} className="reveal max-w-3xl mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--accent))] font-semibold">
            Anbefalinger
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-3 leading-[1.05]">
            Det siger vores{" "}
            <span className="italic font-light text-white/60">partnere.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 lg:gap-7">
          {TESTIMONIALS.map((t, i) => (
            <TestimonialCard key={i} item={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const TestimonialCard = ({ item, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`testimonial-${index}`}
      className="reveal rounded-3xl border border-white/10 bg-[hsl(var(--bg-card))] p-7 lg:p-9 hover:border-[hsl(var(--accent))]/40 transition-colors duration-500"
      style={{ transitionDelay: `${index * 70}ms` }}
    >
      <div className="flex items-center gap-1 text-[hsl(var(--accent))] mb-5">
        {Array.from({ length: item.rating }).map((_, i) => (
          <span key={i}>★</span>
        ))}
      </div>
      <p className="font-display text-lg lg:text-xl leading-relaxed text-white/90">
        “{item.quote}”
      </p>
      <div className="mt-7 flex items-center gap-4 pt-5 border-t border-white/10">
        <div className="h-11 w-11 rounded-full bg-[hsl(var(--accent))]/15 grid place-items-center text-[hsl(var(--accent))] font-bold">
          {item.name.charAt(0)}
        </div>
        <div>
          <div className="font-semibold">{item.name}</div>
          <div className="text-xs text-white/55">{item.role}</div>
        </div>
      </div>
    </div>
  );
};
